import React from "react";
import { MessageSquare, Layers, Palette, CheckCircle } from "lucide-react";
import { PROCESS_STEPS } from "../data/mock";

const ICON_MAP = {
  MessageSquare,
  Layers,
  Palette,
  CheckCircle,
};

export function ProcessSection({ onGetQuote }) {
  return (
    <section id="process" className="py-20 bg-[#FAF8F5]" data-testid="process-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <div className="text-center mb-14">
          <span className="text-[#C9A84C] text-sm font-semibold tracking-widest uppercase">How It Works</span>
          <h2 className="font-serif text-3xl sm:text-4xl font-bold text-[#1a1a1a] mt-2 mb-3">
            Your Journey to a Beautiful Home
          </h2>
          <p className="text-gray-500 max-w-xl mx-auto">
            A simple, transparent 4-step process from consultation to handover
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {PROCESS_STEPS.map((step, i) => {
            const Icon = ICON_MAP[step.icon] || CheckCircle;
            return (
              <div
                key={step.step}
                className="relative text-center"
                data-testid={`process-step-${step.step}`}
              >
                {/* Connector line */}
                {i < PROCESS_STEPS.length - 1 && (
                  <div className="hidden lg:block absolute top-10 left-1/2 w-full h-0.5 bg-[#C9A84C]/20 -z-0" />
                )}

                <div className="relative z-10 flex flex-col items-center">
                  <div className="w-20 h-20 rounded-full bg-[#1a1a1a] flex items-center justify-center mb-5 shadow-lg">
                    <Icon size={28} className="text-[#C9A84C]" />
                  </div>

                  <div className="absolute top-0 right-1/3 bg-[#C9A84C] text-white text-xs font-bold w-6 h-6 rounded-full flex items-center justify-center">
                    {step.step}
                  </div>

                  <h3 className="font-serif text-lg font-bold text-[#1a1a1a] mb-2">{step.title}</h3>
                  <p className="text-gray-500 text-sm leading-relaxed">{step.description}</p>
                </div>
              </div>
            );
          })}
        </div>

        <div className="text-center mt-12">
          <button
            onClick={onGetQuote}
            className="bg-[#C9A84C] text-white font-bold px-10 py-4 rounded-full hover:bg-[#b8933e] transition-colors"
            data-testid="process-cta-btn"
          >
            Start Your Journey Today
          </button>
        </div>
      </div>
    </section>
  );
}
